import { createSlice } from "@reduxjs/toolkit";

export type StreamStatus = 'live'|'scheduled'|'canceled'|'finished';

export interface IStreamStatus {
	id: number,
	name: StreamStatus,
}

export interface StreamStatusState {
	statuses: IStreamStatus[],
	status: IStreamStatus|null,

	creating: boolean,
	deleting: boolean,
	updating: boolean,
	gettingList: boolean,
	gettingItem: boolean,

	isError: boolean,
	errorCode: number,
	errorMessage: string|null,
}

export const initialState: StreamStatusState = {
	statuses: [],
	status: null,

	creating: false,
	deleting: false,
	updating: false,
	gettingList: false,
	gettingItem: false,

	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const StatusSlice = createSlice({
	name: 'status',
	initialState,
	reducers: {

		clearStatusItem: state  => {
			return { ...state, status: null };
		},

		onLoadCreate: (state, action ) => {
			return {...state, creating: true};
		},

		onLoadDelete: (state, action ) => {
			return {...state, deleting: true};
		},

		onLoadArchive: (state, action ) => {
			return {...state, deleting: true};
		},

		onLoadUpdate: (state, action ) => {
			return {...state, updating: true};
		},

		onLoadList: (state, action ) => {
			return {...state, gettingList: true};
		},

		onLoadItem: (state, action ) => {
			return {...state, gettingItem: true};
		},

		// Success
		onSuccessCreate: (state, action) => {
			return {...state, creating: false};
		},

		onSuccessDelete: (state, action) => {
			return {...state, deleting: false};
		},

		onSuccessUpdate: (state, action) => {
			return {...state, updating: false};
		},

		onSuccessList: (state, action) => {
			return {...state, statuses: action.payload.data, gettingList: false};
		},

		onSuccessItem: (state, action) => {
			return {...state, status: action.payload.data, gettingItem: false};
		},

		// Errors
		onFailCreate: (state, action) => {
			return {...state, creating: false };
		},

		onFailDelete: (state, action) => {
			return {...state, deleting: false };
		},

		onFailUpdate: (state, action) => {
			return {...state, updating: false };
		},

		onFailList: (state, action) => {
			return {...state, statuses: [] };
		},

		onFailItem: (state, action) => {
			return {...state, status: null };
		},
	},
});

export const {
	clearStatusItem,
} = StatusSlice.actions;
